const DISPLAY_TYPE_RULES = [
  // Floodie5: all LP-prefixed serials, stored as type "Puck"
  { type: "Puck", serialPrefix: "LP", displayType: "Puck5" },
  // Floodie3: LN- and LM-prefixed serials, stored as type "Puck"
  { type: "Puck", serialPrefix: "LN", displayType: "Puck3" },
  { type: "Puck", serialPrefix: "LM", displayType: "Puck3" },
];

function getDisplayDeviceType(deviceDetails) {
  const type = deviceDetails?.type;
  const serial = (deviceDetails?._id || "").toUpperCase();
  const rule = DISPLAY_TYPE_RULES.find(
    (r) => r.type === type && serial.startsWith(r.serialPrefix)
  );
  return rule ? rule.displayType : type;
}

export default getDisplayDeviceType;
